var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ac-icon",style:(_vm.boxStyle),attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.svg)}})
}
var staticRenderFns = []

export { render, staticRenderFns }